export const SET_CURRENT_ORGANISATION = 'organisation/SET_CURRENT_ORGANISATION';
export const SET_ORGANISATION_NAVBAR = 'organisation/SET_ORGANISATION_NAVBAR';
export const SET_ORGANISATION_USER = 'dashboard/SET_ORGANISATION_USER';
export const SET_LOADER = 'organisation/SET_LOADER';
